import React from "react";

const Spinner = () => {
  return (
    <div className="spinner-box">
      <div className="spinner-border"></div>
    </div>
  );
};

export default Spinner;
